<div class="card">
  <div class="card-header">
    <h4>Remittance Earning Report</h4>
  </div>
  <div class="card-body m-0">
    <div class="row mb-2">
      <div class="col-xl-10">
        <button type="button" class="btn bg-danger-custom" 
        *ngIf="permissions.includes('Search')"
          (click)="onExportCSV()" [disabled]="loading || collectionSize === 0">
          <i class="feather icon-download me-2"></i>Export Excel
        </button>
        <button type="button" class="btn bg-danger-custom" 
        *ngIf="permissions.includes('Search')"
           (click)="onBackgroundExport()" [disabled]="loading">
          <i class="feather icon-download me-2"></i>Export All
        </button>
        <button type="button" class="btn bg-danger-custom" (click)="quickFilterShowAction($event)">
          <i class="feather icon-filter me-2"></i>Quick Filters
        </button>
        <div class="btn-group mb-1 mb-md-0">
          <div class="btn-group" ngbDropdown role="group">
            <button class="btn bg-danger-custom" ngbDropdownToggle>
              <i class="feather icon-columns me-2"></i>Columns
            </button>
            <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
              style="height: 400px; width: 300px; overflow: scroll; scroll-behavior: smooth">
              <div class="form-group">
                <div *ngIf="columnDefs" class="list-group ng-option">
                  <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                    <label class="list-group-item p-2">
                      <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" 
                        [value]="i" [name]="column.headerName" (change)="updateSelectedColumn($event)"
                        [checked]="(tableSelectedColumn && (-1 !== tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                      {{ (column?.headerName?.replace('_','') || column?.field?.replace('_','')) }}
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      <div class="card">
        <div class="card-body">
          <!-- First row: 3 3 3 3 -->
          <div class="row">
            <div class="col-sm-3">
              <label class="col-form-label" for="txnId">Transaction ID</label>
              <input class="form-control" id="txnId" [(ngModel)]="txnId" type="text" 
                name="txnId" placeholder="Enter Transaction ID" autocomplete="new-password">
            </div>
            <div class="col-sm-3">
              <label class="col-form-label" for="walletId">Wallet ID</label>
              <input class="form-control" id="walletId" [(ngModel)]="walletId" type="text" 
                name="walletId" placeholder="Enter Wallet ID" autocomplete="new-password">
            </div>
            <div class="col-sm-3">
              <label class="col-form-label" for="customerMobile">Customer Mobile</label>
              <input class="form-control" id="customerMobile" [(ngModel)]="customerMobile" type="text" 
                name="customerMobile" placeholder="Enter Customer Mobile" autocomplete="new-password">
            </div>
            <div class="col-sm-3">
              <label class="col-form-label" for="receiveCurrency">Receive Currency</label>
              <select class="form-control" id="receiveCurrency" [(ngModel)]="receiveCurrency" name="receiveCurrency">
                <option value="">All</option>
                <option *ngFor="let curr of currencyOptions" [value]="curr">{{curr}}</option>
              </select>
            </div>
          </div>
          <br>
          <!-- Second row: 3 3 3 -->
          <div class="row">
            <div class="col-sm-3">
              <label class="col-form-label" for="dateFrom">From Date</label>
              <input #filSearchFromDate [(ngModel)]="dateFrom" name="dateFrom" class="form-control" 
                id="dateFrom" max="{{dateTo|date:'yyyy-MM-dd'}}" type="date" />
            </div>
            <div class="col-sm-3">
              <label class="col-form-label" for="dateTo">To Date</label>
              <input #filSearchToDate [(ngModel)]="dateTo" name="dateTo" class="form-control" 
                id="dateTo" min="{{dateFrom|date:'yyyy-MM-dd'}}" max="{{getToday()}}" type="date" />
            </div>
            <div class="col-sm-3">
              <label class="col-form-label" for="serviceProviderCode">Service Provider</label>
              <select class="form-control" id="serviceProviderCode" [(ngModel)]="serviceProviderCode" name="serviceProviderCode">
                <option value="">All</option>
                <option *ngFor="let sp of spOptions" [value]="sp">{{sp}}</option>
              </select>
            </div>
            <div class="col-sm-3 d-flex align-items-end">
              <button (click)="onSearchPayments()" class="btn bg-danger-custom w-100" type="button" [disabled]="loading">
                <i class="feather icon-search me-2"></i>Search
              </button>
              <button (click)="resetFilters()" class="btn bg-secondary w-100" type="button" [disabled]="loading">
                <i class="feather icon-refresh-cw me-2"></i>Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!loading" class="row mb-0" style="min-height: 470px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
        <ag-grid-angular [enableCellTextSelection]=true
          (gridReady)="onGridReady($event)" [columnDefs]="tableSelectedColumn"
          [defaultColDef]="defaultColDef" [enableCellTextSelection]=true 
          [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" 
          [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
          style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>

    <!-- <div *ngIf="!loading && rowData && rowData.length > 0" class="mt-3 p-3 bg-light rounded">
      <div class="row">
        <div class="col-md-4">
          <strong>Total Records:</strong> {{ collectionSize }}
        </div>
        <div class="col-md-4">
          <strong>Total FX Earning:</strong> {{ calculateTotal(rowData, 'fxEarningAED') | number:'1.2-2' }} AED
        </div>
        <div class="col-md-4">
          <strong>Total Fee Earning:</strong> {{ calculateTotal(rowData, 'feeEarning') | number:'1.2-2' }} AED
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4">
          <strong>Total Earning:</strong> {{ calculateTotal(rowData, 'totalEarning') | number:'1.2-2' }} AED
        </div>
        <div class="col-md-4">
          <strong>Total Amount:</strong> {{ calculateTotal(rowData, 'totalAmount') | number:'1.2-2' }} AED
        </div>
        <div class="col-md-4">
          <strong>Total Receive Amount:</strong> {{ calculateTotal(rowData, 'receiveAmount') | number:'1.0-0' }}
        </div>
      </div>
    </div> -->

    <div *ngIf="!loading" class="row mt-0">
      <div class="col-4 col-xs-4 d-flex">
        <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
      </div>

      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
          [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
          [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>
